module.exports = __webpack_public_path__ + "img/voucher-used.229d3d73.svg";